import { render, staticRenderFns } from "./CorporateDetail.vue?vue&type=template&id=5ae44d96&scoped=true&"
import script from "./CorporateDetail.vue?vue&type=script&lang=js&"
export * from "./CorporateDetail.vue?vue&type=script&lang=js&"
import style0 from "./CorporateDetail.vue?vue&type=style&index=0&id=5ae44d96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae44d96",
  null
  
)

export default component.exports